export const refreshPatreonUserInfoSaga = 'REFRESH_PATREON_USER_INFO_SAGA';
export const refreshPatreonMembershipsSaga = 'REFRESH_PATREON_MEMBERSHIPS_SAGA';
export const getMembershipCreatorRecordsSaga = 'GET_MEMBERSHIP_CREATOR_RECORDS_SAGA';
export const receiveMembershipCreatorRecords = 'RECEIVE_MEMBERSHIP_CREATOR_RECORDS';
export const getPatreonPostsSaga = 'GET_PATREON_POSTS_SAGA';
export const getPatreonPostsForRnryUserIdSaga = 'GET_PATREON_POSTS_FOR_RNRY_USER_ID_SAGA';
export const getPatreonPostsForTnsUserIdSaga = 'GET_PATREON_POSTS_FOR_TNS_USER_ID_SAGA';
export const receivePatreonPosts = 'RECEIVE_PATREON_POSTS';
export const setIsLoadingPatreonPosts = 'SET_IS_LOADING_PATREON_POSTS';